export default __webpack_public_path__ + "static/media/controlReminder24.41134ca4.svg";